module.exports = __webpack_public_path__ + "media/images/icon-other-ce1503b5b846a6e78811e2c3d66b5afe.png";